
import { 
  HeroSection, 
  FeaturedTreksSection, 
  CompaniesSection, 
  CTASection,
  FooterSection
} from '@/components/sections';
import SEO from '@/components/SEO';
import SearchPortal from '@/components/SearchPortal';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Analytics from '@/lib/analytics';
import { preloadCriticalResources } from '@/utils/preloadResources';

const Index = () => {
  // Check if we're in a development environment
  const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';
  
  // Track homepage visit directly
  useEffect(() => {
    Analytics.track('Homepage Visit', {
      timestamp: new Date().toISOString()
    });
    console.log('[Index] Homepage loaded and tracking triggered');
    
    // Preload critical resources for faster navigation from homepage
    preloadCriticalResources('home');
  }, []);
  
  // Structured data for the homepage
  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "GoTrekking",
    "url": "https://gotrekking.in",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://gotrekking.in/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "description": "Find and compare the best trek packages from top adventure companies in India. Get detailed information on popular Himalayan treks and book your perfect adventure.",
    "publisher": {
      "@type": "Organization",
      "name": "GoTrekking",
      "logo": {
        "@type": "ImageObject",
        "url": "https://gotrekking.in/logo.png"
      }
    }
  };
  
  return (
    <main className="overflow-x-hidden">
      <SearchPortal />
      <SEO 
        title="GoTrekking - Compare Trek Packages for Your Perfect Adventure"
        description="Find and compare the best trek packages from top adventure companies in India. Get detailed information on popular Himalayan treks and book your perfect adventure."
        keywords="trekking, hiking, adventure, Himalayas, trek packages, India, adventure companies, mountain treks"
        jsonLd={homeJsonLd}
      />
      <div className="bg-nature-50/30">
        <HeroSection />
        <FeaturedTreksSection />
      </div>
      <CompaniesSection />
      <CTASection />
      <FooterSection />
      
      {/* Admin Panel Link - only shown in development mode */}
      {isDev && (
        <div className="fixed bottom-4 right-4 z-50">
          <Link to="/admin">
            <Button variant="outline" size="sm" className="bg-card shadow-md flex items-center gap-2">
              <Shield className="h-4 w-4" />
              Admin Panel
            </Button>
          </Link>
        </div>
      )}
    </main>
  );
};

export default Index;
